/**
 * Carried over from the previous portfolio, prose intact. Reference links use
 * `[label](href)` so the copy stays plain data - see components/RichText.js.
 */
const skills = [
    {
        id: 'frontend',
        title: 'Frontend Coding',
        badge: 'HTML / CSS / JS',
        teaser: 'Structure, style and behaviour - the whole client side.',
        body:
            'With over 10 years of experience, I am fluent in [HTML](https://www.w3schools.com/html/html_intro.asp), [CSS](https://www.w3schools.com/css/css_intro.asp), and JavaScript, crafting seamless user experiences with a touch of creativity and a lot of precision. From structuring content to styling pixels and scripting interactivity, I turn design ideas into responsive, accessible, high-performance web pages.'
    },
    {
        id: 'frameworks',
        title: 'JS Frameworks',
        badge: 'React / Angular / Vue',
        teaser: 'Modern frameworks, plus the legacy stacks nobody volunteers for.',
        body:
            'I have extensive experience building web applications with modern frameworks such as [React](https://react.dev/) & [Next.js](https://nextjs.org/), [Angular](https://angular.io/), and [Vue.js](https://vuejs.org/). My background also includes working with legacy technologies like [jQuery](https://jquery.com/), [Dojo Toolkit](https://dojotoolkit.org/), and [BootstrapJS](https://getbootstrap.com/), which gives me a strong foundation for modernizing and refactoring older codebases to meet today’s standards.'
    },
    {
        id: 'workspace',
        title: 'Workspace',
        badge: 'Git / npm / Node',
        teaser: 'Version control, packages and a local server that just works.',
        body:
            'I use [Git](https://git-scm.com/) for version control to efficiently manage and track changes across all my project files, ensuring a smooth and collaborative workflow. For package management, I rely on [npm](https://www.npmjs.com/) to install and maintain dependencies. My development environment includes [Node.js](https://nodejs.org/) and [Express](https://expressjs.com/) for running local servers, and I often use tools like [JSONPlaceholder](https://jsonplaceholder.typicode.com/) to quickly prototype APIs and endpoints during the early stages of a project. This setup allows me to iterate rapidly and maintain a clean, organized codebase.'
    },
    {
        id: 'responsive',
        title: 'Responsive Design',
        badge: 'Figma / Photoshop',
        teaser: 'Mobile, tablet, desktop - designed and built for all three.',
        body:
            'I have extensive experience using Adobe products such as [Photoshop](https://www.adobe.com/products/photoshop.html) and [Illustrator](https://www.adobe.com/products/illustrator.html) to create and refine visual assets for the web. In addition, I have worked with modern design tools like [Sketch](https://www.sketch.com/) and [Figma](https://www.figma.com/), which help bridge the gap between design and front-end development. I am skilled at developing for all screen sizes — mobile, tablet, and desktop — by utilizing [mobile-first](https://developer.mozilla.org/en-US/docs/Glossary/Mobile_First), [responsive design](https://www.w3schools.com/html/html_responsive.asp) principles to ensure a seamless user experience across devices.'
    },
    {
        id: 'strength',
        title: 'Strength',
        badge: 'Team player',
        teaser: 'Collaborative, resourceful, and happy to be the one who digs in.',
        body:
            'I am a collaborative team player who enjoys working with others to achieve shared goals. But, I am also resourceful and self-reliant, I actively seek out solutions and am always willing to lend a hand to colleagues. My friendly and approachable nature helps foster a positive work environment, and I am committed to continuously learning and improving my understanding of code and best practices.'
    },
    {
        id: 'weakness',
        title: 'Weakness',
        badge: 'Backend depth',
        teaser: 'Frontend deep, backend shallow - and honest about which.',
        body:
            'While I excel at frontend development and crafting engaging user interfaces, I have limited experience working with middleware services and databases. My skills complement backend developers very well, as I focus on building robust and polished client-side experiences. I know just enough about backend technologies for prototyping, but I rely on collaboration with backend experts for production-ready solutions.'
    }
];

export default skills;
